import { Injectable, inject, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { finalize, Observable, shareReplay, tap } from 'rxjs';
import { LoginRequest } from '../../../models/auth.models';
import { CurrentUserResponse } from '../../../models/admin-dashboard.models';
@Injectable({
  providedIn: 'root',
})
export class Auth {
  private http = inject(HttpClient);
  private router = inject(Router);

  // Fine-grained reactive signals tracking structural state properties
  isSubmitting = signal<boolean>(false);
  private currentUserCache$: Observable<any> | null = null

  public currentUser = signal<any>(null)
  //   // Modern Angular Signals state tracking
  isAuthenticated = signal<boolean>(this.hasValidToken());

  isLoggedIn(): boolean {
    return !!localStorage.getItem('authToken');
  }

  login(credentials: LoginRequest): Observable<any> {
    this.isSubmitting.set(true);

    return this.http.post<any>('/api/v1/login', credentials).pipe(
      tap((res) => {
        if (res?.success && res.data?.token) {
          localStorage.setItem('authToken', res.data.token);
          this.isAuthenticated.set(true);
        }
      }),
      finalize(() => this.isSubmitting.set(false)),
    );
  }

  private hasValidToken(): boolean {
    const token = localStorage.getItem('auth_token');
    return !!token; // For advanced validation, decode and verify expiration time if using JWT
  }

  getCurrentUserDeatils(): Observable<CurrentUserResponse> { 
    if (!this.currentUserCache$) {
      this.currentUserCache$ = this.http.get<any>('/api/v1/user_details').pipe(
        tap(response => this.currentUser.set({
          user_type: response.user_type,
          user: response.data.user
        })),
        shareReplay(1)
      );
    }
    return this.currentUserCache$;
  }

  logout(): void {
    localStorage.clear();
    this.isAuthenticated.set(false);
    this.router.navigate(['/login']);
    this.currentUserCache$ = null;
    this.currentUser.set(null);
    
  }
}
